import { initialCartState } from "@jti/store/slices/cartSlice";
import { fromMagentoCurrency } from "@jti/store/utils";

import type { MagentoBootstrapData } from "@/app/_internal/getMagentoBootstrapData";

import type { PreloadedStateSlice } from "../buildPreloadedState";
import { toCartStoreConfig } from "../toCartStoreConfig";

export const buildCartPreloadedState = (magentoBootstrapData?: MagentoBootstrapData): PreloadedStateSlice => {
  if (!magentoBootstrapData?.currency && !magentoBootstrapData?.storeConfig) {
    return undefined;
  }

  return {
    cart: {
      ...initialCartState,
      ...(magentoBootstrapData.currency && {
        currency: fromMagentoCurrency(magentoBootstrapData.currency),
        fetchCurrencyStatus: "success",
      }),
      ...(magentoBootstrapData.storeConfig && {
        storeConfig: toCartStoreConfig(magentoBootstrapData.storeConfig),
        fetchStoreConfigStatus: "success",
      }),
    },
  };
};
